<template>
  <section class="tw-pb-14 sm:tw-pb-16 md:tw-pb-20 tw-flex tw-flex-col tw-gap-14 sm:tw-gap-16 lg:tw-gap-20">
    <div class="tw-bg-accent">
      <CommonHeader is-light />
      <section class="tw-container tw-mx-auto tw-py-14 sm:tw-py-16 md:tw-py-24 lg:tw-py-28">
        <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-6">
          <div class="tw-basis-full md:tw-basis-1/2 md:tw-order-last">
            <NuxtImg src="/res/img/trading/trade-bg.png" />
          </div>
          <div class="tw-basis-full md:tw-basis-1/2 tw-flex tw-items-center">
            <div class="tw-text-center md:tw-text-left">
              <h2 class="tw-text-3xl md:tw-text-5xl lg:tw-text-6xl tw-font-black tw-text-primary !tw-leading-normal">{{
                $t('legend-otc')
              }}</h2>
              <p class="tw-text-sm sm:tw-text-base md:tw-text-xl lg:tw-text-2xl tw-mt-5 tw-text-white !tw-leading-normal">
                {{
                  $t(
                    'our-over-the-counter-otc-trading-service-is-trusted-by-over-800-institutional-clients-it-sets-the-gold-standard-for-global-liquidity-regulatory-compliance-robust-infrastructure-and-settlement-efficiency',
                  )
                }}
              </p>
              <div class="tw-mt-10">
                <UIButton to="/kyc" theme="primary-2" class="tw-btn-lg md:tw-btn-xl xl:tw-btn-2xl tw-uppercase">
                  {{ $t('trade-with-us') }}
                </UIButton>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <section class="tw-max-w-screen-lg tw-mx-auto tw-px-6 wow fadeIn" data-wow-delay="0.2s">
      <div class="tw-text-center tw-mb-5 sm:tw-mb-8 md:tw-mb-10 lg:tw-mb-12">
        <h3 class="tw-text-2xl md:tw-text-3xl lg:tw-text-4xl tw-font-black !tw-leading-normal">{{
          $t('trusted-by-800-institutions-including')
        }}</h3>
      </div>
      <PartnerShipsLegendOTC />
    </section>

    <section class="tw-bg-secondary tw-px-5 tw-overflow-hidden">
      <section class="tw-max-w-screen-xl tw-mx-auto tw-flex tw-flex-col tw-gap-14 sm:tw-gap-16 md:tw-gap-20 tw-py-14 sm:tw-py-16 md:tw-py-20">
        <h5 class="tw-text-primary tw-text-center tw-text-lg md:tw-text-xl tw-font-black ">
          {{ $t('otc-trading-services') }}
        </h5>
        <div class="tw-flex tw-flex-col">
          <div v-for="(item, index) in serviceList" :key="index">
            <div class="tw-flex tw-flex-col md:tw-flex-row tw-flex-wrap">
              <div class="tw-basis-full md:tw-basis-7/12 tw-flex tw-items-center" :class="`tw-order-${index % 2 === 0 ? 1 : 2}`">
                <div class="tw-flex tw-flex-col">
                  <div
                    class="tw-flex tw-justify-between md:tw-justify-start tw-items-center"
                    :class="{
                      'tw-text-right': index % 2 !== 0,
                    }"
                  >
                    <h3
                      class="tw-text-2xl md:tw-text-3xl lg:tw-text-4xl tw-font-black !tw-leading-normal"
                      :class="{ 'tw-order-2': index % 2 !== 0 }"
                    >
                      {{ item.title }}
                    </h3>
                    <NuxtImg class="md:tw-hidden tw-w-[100px]" :src="item.imgPath" :alt="item.altText" />
                  </div>
                  <p class="tw-text-base md:tw-text-lg tw-mt-4">{{ item.subTitle }}</p>
                </div>
              </div>
              <div class="tw-basis-full md:tw-basis-5/12 tw-hidden md:tw-block" :class="`tw-order-${index % 2 === 0 ? 2 : 1}`">
                <NuxtImg class="tw-mx-auto" :src="item.imgPath" :alt="item.altText" />
              </div>
              <div class="tw-basis-full tw-order-3">
                <div
                  class="tw-bg-white tw-rounded-lg tw-text-base tw-mt-5 sm:tw-mt-8 md:tw-mt-10 lg:tw-mt-12 tw-px-6 sm:tw-px-8 md:tw-px-9 lg:tw-px-10 tw-py-6 md:tw-py-5"
                  v-if="item.extraDescribe"
                  >{{ item.extraDescribe }}
                </div>
              </div>
            </div>
            <div class="tw-py-7 sm:tw-py-8 md:tw-py-10 lg:tw-py-14" v-if="index !== serviceList.length - 1">
              <VLine type="lightToDark" class="tw-h-px md:tw-h-0.5" />
            </div>
          </div>
        </div>
      </section>
    </section>

    <section class="tw-container tw-mx-auto tw-text-center tw-text-white tw-flex-none tw-w-full">
      <div class="tw-bg-accent tw-px-6 wow flipUp tw-py-14 sm:tw-py-16 md:tw-py-20 tw-rounded-2xl md:tw-rounded-3xl" data-wow-delay="0.2s">
        <h3 class="tw-text-2xl md:tw-text-3xl lg:tw-text-4xl tw-font-black !tw-leading-normal">{{ $t('get-started-today') }}</h3>
        <p class="tw-text-base md:tw-text-lg tw-mt-5 md:tw-mt-2 tw-mb-10">
          {{ $t('the-leading-u-s-regulated-crypto-trading-firm-trusted-by') }}
          {{ $t('800-institutions') }}
        </p>
        <UIButton to="/kyc" theme="primary-2" class="tw-btn-lg md:tw-btn-xl xl:tw-btn-2xl tw-uppercase">
          {{ $t('trade-with-us') }}
        </UIButton>
      </div>
    </section>
  </section>
</template>

<script lang="ts" setup>
  const { t } = useI18n()
  const serviceList = computed(() => [
    {
      title: t('deep-liquidity-and-competitive-quotes'),
      subTitle: t(
        'legend-trading-has-its-proprietary-smart-order-routing-system-that-allows-our-clients-to-access-a-huge-and-centralized-liquidity-pool-that-aggregates-cryptocurrency-liquidity-globally-many-exchanges-are-also-our-direct-clients-and-trade-with-us-constantly-by-doing-so-we-can-offer-competitive-quotes-especially-for-block-trades',
      ),
      extraDescribe: t(
        'our-trade-execution-helps-control-slippages-and-tighten-spreads-significantly-by-working-with-legend-trading-institutional-clients-are-able-to-obtain-the-best-trade-values-of-the-crypto-assets',
      ),
      imgPath: `/res/img/trading/otc-liquidity-icon.svg`,
      altText: 'otc-liquidity-icon',
    },
    {
      title: t('world-class-trading-experience'),
      subTitle: t(
        '24-7-electronic-execution-for-major-digital-assets-and-fiat-currency-trading-pairs-our-professional-traders-are-responsive-and-ready-to-meet-your-trading-needs-anytime-feel-free-to-leverage-our-teams-extensive-expertise-in-cryptocurrency-and-financial-markets',
      ),
      extraDescribe: '',
      imgPath: `/res/img/trading/otc-worldclass-icon.svg`,
      altText: 'otc-worldclass-icon',
    },
    {
      title: t('highly-efficient-settlements'),
      subTitle: t(
        'legend-trading-works-closely-with-a-large-network-of-banks-financial-institutions-and-crypto-custodians-we-are-proud-of-our-fast-and-automated-settlements-of-digital-assets-and-7-major-fiat-currencies-including-usd-eur-gbp-aud-cad-chf-and-jpy',
      ),
      extraDescribe: '',
      imgPath: `/res/img/trading/otc-settlement-icon.svg`,
      altText: 'otc-settlement-icon',
    },
  ])
  definePageMeta({
    middleware: ['sosovalue','ip2location'],
  })
</script>
